/* eslint-disable import/no-named-as-default */
/* global window */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { IntlActions, IntlProvider } from 'react-redux-multilingual';

import ErrorBoundary from 'Views/Shared/ErrorBoundary/ErrorBoundary';
import translations from 'SiteConfigs/translations-config';
import configureStore from 'SiteConfigs/configureStore';

import { requestPostProfile } from 'Actions/AlertsActions';
import { requestUserInfo } from 'Actions/UserActions';

import getTokenPromise from './getTokenPromise';

const { MD } = window;

export const updateLanguage = (store, language) => {
	store.dispatch(IntlActions.setLocale(language));
	store.dispatch(requestPostProfile({ languageCode: language }));
	if (window.format) {
		window.format.myLocale(language);
		window.format.setDocumentLocale(language);
	}
};

export const ComponentWrapper = ({ storeConfiguration, children }) => (
	<ErrorBoundary>
		<Provider store={storeConfiguration.store}>
			<PersistGate loading={null} persistor={storeConfiguration.persistor}>
				<IntlProvider translations={translations}>
					{children}
				</IntlProvider>
			</PersistGate>
		</Provider>
	</ErrorBoundary>
);

// This won't work for all cases forever, but it works for all cases now.
export const standardMountToElementBuilder = reactComponent => (
	el, { mdComponent, attributeChangedEventManager }
) => {
	let instance = <></>;
	getTokenPromise().then(() => {
		const storeConfiguration = configureStore();

		if (MD && MD.apiBaseCibcUrl) {
			// make the request for the user info.
			storeConfiguration.store.dispatch(requestUserInfo());
		}

		updateLanguage(storeConfiguration.store, mdComponent.getAttribute('language') || 'en');
		attributeChangedEventManager.addEventHandler('language', value => updateLanguage(storeConfiguration.store, value || 'en'));


		instance = (
			<ComponentWrapper storeConfiguration={storeConfiguration}>
				{reactComponent}
			</ComponentWrapper>
		);

		ReactDOM.render(instance, el);
	});

	return instance;
};
